import { getID } from '../../Reusable/O3DG2'

export class Buildings {
  constructor () {
    this.list = [
      {
        _id: getID(),
        labelY: 100,
        name: 'hospital',
        displayName: 'Hospital 1',
        component: 'CityHospitalShort',
        img: require('./UIs/building/hospital1.png')
      },
      {
        _id: getID(),
        name: 'hospitaltall',
        labelY: 120,
        displayName: 'Hospital 2',
        component: 'CityHospital',
        img: require('./UIs/building/hospital2.png')
      },
      {
        _id: getID(),
        name: 'office',
        labelY: 100,
        displayName: 'Office',
        component: 'CityOffice',
        img: require('./UIs/building/office.png')
      },
      {
        _id: getID(),
        name: 'housing',
        labelY: 100,

        displayName: 'Housing',
        component: 'CityHousing',
        img: require('./UIs/building/housing.png')
      }
    ]
  }
}